import { batch } from 'react-redux';
import { getMeetingRooms } from '../../../api/meetingRooms';
import type { MeetingRoom } from './types';
import type { AppThunk } from '../../../store';
import { setIsLoading, setMeetingRooms } from './index';
import { fetchTenant } from '../../Organizations/OrganizationsSlice/actionCreators';

export const fetchMeetingRooms = (): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(setIsLoading(true));

    let tenant = getState().organizations.tenant;
    if (!tenant) {
      await dispatch(fetchTenant());
      tenant = getState().organizations.tenant;
      if (!tenant) {
        throw new Error('Missing tenant');
      }
    }

    const { data, error } = await getMeetingRooms({ tenantId: tenant.id, limit: 30, offset: 0 });
    if (error) {
      throw new Error('Error when retrieving meeting rooms');
    }
    if (data.metadata.pagination.totalCount > data.metadata.pagination.limit) {
      console.warn('There are meeting rooms which have not been fetched');
    }

    batch(() => {
      const meetingRooms: MeetingRoom[] = data.data.map(mr => {
        return {
          id: mr.id,
          name: mr.name,
          description: mr.description,
          url: mr.url,
        };
      });
      dispatch(setMeetingRooms(meetingRooms));
      dispatch(setIsLoading(false));
    });
  } catch (error) {
    dispatch(setIsLoading(false));
    console.log('error log ', error);
  }
};

export const resetMeetingRoomStoreData = (): AppThunk => async dispatch => {
  dispatch(setMeetingRooms([]));
  dispatch(setIsLoading(false));
};
